// extracted by mini-css-extract-plugin
module.exports = {"list":"sideDrawer-module--list--zGo0o","linkText":"sideDrawer-module--linkText--RSCrd"};